export default __webpack_public_path__ + "83e094e975c84e17f358ecb676c95d2c.svg";